import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Outlet, Route } from 'react-router';
import { AddRolePage, EditRolePage, RolesPage } from '#route-bundles/authenticated.tsx';
import { fallbackRenderNotFound } from '#screens/errors/fallbackRenderNotFound.tsx';
import { LoadingSpinner } from '#screens/loading/LoadingSpinner.tsx';
import { fromArray, Titled } from '#util/title.ts';

/**
 * {@link rolesRootRoute} contains all of the routing config for the /roles path
 */
export const rolesRootRoute = (
  <Route
    element={
      <Titled title={(title) => fromArray(['Roles', title])}>
        <Suspense fallback={<LoadingSpinner />}>
          <Outlet />
        </Suspense>
      </Titled>
    }
  >
    <Route index={true} element={<RolesPage />} />
    <Route path="add" element={<AddRolePage />} />
    <Route
      path=":roleId"
      element={
        <ErrorBoundary fallbackRender={fallbackRenderNotFound}>
          <EditRolePage />
        </ErrorBoundary>
      }
    />
  </Route>
);
